import { cn } from "@/src/lib/utils";
import { Text } from "@/src/components/ui/Typography";

export interface AvatarProps {
  src?: string;
  alt: string;
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASSES = {
  sm: "h-8 w-8",
  md: "h-12 w-12",
  lg: "h-28 w-28",
} as const;

const INITIALS_TEXT_SIZE = {
  sm: "labelSM",
  md: "labelLG",
  lg: "titleLG",
} as const;

function getInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

export function Avatar({ src, alt, name, size = "md", className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={cn(SIZE_CLASSES[size], "shrink-0 rounded-full object-cover", className)}
      />
    );
  }

  return (
    <div
      className={cn(
        SIZE_CLASSES[size],
        "flex shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand",
        className,
      )}
      aria-hidden
    >
      <Text as="span" size={INITIALS_TEXT_SIZE[size]} className="text-brand font-medium">
        {getInitials(name)}
      </Text>
    </div>
  );
}
